export const ASSIGN_POINTS      = "ASSIGN_POINTS";
export const CHANGE_SCREEN      = "CHANGE_SCREEN";
export const CONTINUE           = "CONTINUE";
export const EJECT              = "EJECT";
export const ENABLE_COUNTDOWN   = "ENABLE_COUNTDOWN";
export const HIDE_COUNTDOWN     = "HIDE_COUNTDOWN";
export const LOAD_MOVIES        = "LOAD_MOVIES";
export const SELECT_PLAYER      = "SELECT_PLAYER";
export const SET_ANSWER         = "SET_ANSWER";
export const SET_CATEGORY       = "SET_CATEGORY";
export const SET_CLUES          = "SET_CLUES";
export const SET_CLUES_EXTRA    = "SET_CLUES_EXTRA";
export const SET_GUESS          = "SET_GUESS";
export const SET_NUM_PLAYERS    = "SET_NUM_PLAYERS";
export const SET_PHOTO_INDEX    = "SET_PHOTO_INDEX";
export const SET_PLAYER_ICON    = "SET_PLAYER_ICON";
export const SET_PLAYER_NAME    = "SET_PLAYER_NAME";
export const SET_SHARE_SCREEN   = "SET_SHARE_SCREEN";
export const SET_SHOW_ANSWERS   = "SET_SHOW_ANSWERS";
export const SET_SOUND_EFFECTS  = "SET_SOUND_EFFECTS";
export const SET_SUBCATEGORY    = "SET_SUBCATEGORY";
export const SET_SWIPE_CONTROLS = "SET_SWIPE_CONTROLS";
export const SHOW_CLUES_EXTRA   = "SHOW_CLUES_EXTRA";
export const SHOW_HISTORY       = "SHOW_HISTORY";
export const SHOW_HOW_TO_PLAY   = "SHOW_HOW_TO_PLAY";
export const SHOW_NEXT_CLUE     = "SHOW_NEXT_CLUE";
export const SHOW_PHOTO_MODAL   = "SHOW_PHOTO_MODAL";
export const START_ROUND        = "START_ROUND";
export const SUBMIT_GUESS       = "SUBMIT_GUESS";
export const SWITCH_HOW_TO_PLAY = "SWITCH_HOW_TO_PLAY";